// Validating the JSA Hazards V2

// We only need to validate the "otherDescribe" field for the JSA Hazards V2
export const validateJsaHazardsV2 = (jsaHazards) => {
  const errors = {};

  if (jsaHazards.other) {
    if (jsaHazards.otherDescribe.trim() === "") {
      errors.otherDescribe = "Please describe the hazard";
    }
  }

  return errors;
};
